import { type ReactNode } from 'react';
import { SeverityBar, type Severity } from './SeverityBar';

export type FindingRowProps = {
  id: string;
  title: ReactNode;
  context?: ReactNode;
  severity: Severity;
  category: string;
  status?: 'open' | 'acknowledged' | 'dismissed' | 'snoozed' | 'bpx_in_progress';
  caseRef?: string;
  age?: string;
  /** Interactive elements must call e.stopPropagation() in their handlers to prevent the row's onClick from firing. */
  ctas?: ReactNode;
  onClick?: () => void;
};

export function FindingRow(props: FindingRowProps) {
  const dim = props.status === 'snoozed' || props.status === 'dismissed';
  const bpx = props.status === 'bpx_in_progress';
  return (
    <button
      type="button"
      onClick={props.onClick}
      className={`group w-full flex items-stretch gap-3 px-4 py-3 border rounded-lg text-left shadow-card transition-all ${
        bpx
          ? 'border-sfblue/40 bg-sfblue/10 hover:border-sfblue/60 hover:bg-sfblue/15'
          : 'border-border-subtle bg-surface-2 hover:bg-surface-hover hover:border-border-strong hover:shadow-card-hover'
      } ${dim ? 'opacity-55' : ''}`}
    >
      <SeverityBar severity={props.severity} />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-text-strong truncate">{props.title}</div>
        <div className="text-xs text-text-muted mt-1 truncate">
          <span className="font-medium">{props.category}</span>
          {props.context ? <> · {props.context}</> : null}
          {props.age ? <> · {props.age}</> : null}
          {bpx && props.caseRef ? <> · <span className="text-sfblue">{props.caseRef}</span></> : null}
        </div>
      </div>
      {props.ctas && <div className="flex items-center gap-1.5 text-xs">{props.ctas}</div>}
    </button>
  );
}
